import { render, staticRenderFns } from "./DemoMenu.vue?vue&type=template&id=7ae503f9&scoped=true&"
import script from "./DemoMenu.vue?vue&type=script&lang=js&"
export * from "./DemoMenu.vue?vue&type=script&lang=js&"
import style0 from "./DemoMenu.vue?vue&type=style&index=0&id=7ae503f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae503f9",
  null
  
)

export default component.exports